import axios from '@axios';
// import HelperService from '@/services/HelperService';

// const helperService = new HelperService();
const base = '/api/v1/visits';

export default {
  updateWaitingRoomStatus(callId, status) {
    return axios.post(`${base}/call-state/set-visitor-in-waiting-room/${callId}`, status);
  },
};
